export default __webpack_public_path__ + "static/media/avatar.21519c3b.png";